import { http, HttpResponse } from 'msw';

import { mockTruktTmsApiUrl } from '../mocks';
import {
  VehicleBodyTypesSearchResponse,
  VehicleBodyWeightClassSearchResponse,
} from '../services/VehicleService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/vehicles/body-types'), () => {
    return HttpResponse.json<VehicleBodyTypesSearchResponse>({
      page: 0,
      rows: 100,
      total: 20,
      results: [
        {
          type: 'coupe',
        },
        {
          type: 'convertible',
        },
        {
          type: 'sedan',
        },
        {
          type: 'SUV',
        },
        {
          type: 'minivan',
        },
        {
          type: 'pickup truck (2 door)',
        },
        {
          type: 'pickup truck (4 door)',
        },
        {
          type: 'pickup dually',
        },
        {
          type: 'motorcycle',
        },
        {
          type: 'ATV',
        },
        {
          type: 'boat',
        },
        {
          type: 'RV',
        },
        {
          type: 'trailer (5th wheel)',
        },
        {
          type: 'trailer (bumper pull)',
        },
        {
          type: 'trailer (gooseneck)',
        },
        {
          type: 'cargo van',
        },
        {
          type: 'box truck',
        },
        {
          type: 'day cab',
        },
        {
          type: 'sleeper cab',
        },
        {
          type: 'other',
        },
      ],
    });
  }),
  http.get(mockTruktTmsApiUrl('/vehicles/weight-classes'), () => {
    return HttpResponse.json<VehicleBodyWeightClassSearchResponse>({
      page: 0,
      rows: 100,
      total: 8,
      results: [
        {
          id: '1',
          class: '1',
          minWeight: 0,
          maxWeight: 6000,
        },
        {
          id: '2',
          class: '2',
          minWeight: 6001,
          maxWeight: 10000,
        },
        {
          id: '3',
          class: '3',
          minWeight: 10001,
          maxWeight: 14000,
        },
        {
          id: '4',
          class: '4',
          minWeight: 14001,
          maxWeight: 16000,
        },
        {
          id: '5',
          class: '5',
          minWeight: 16001,
          maxWeight: 19500,
        },
        {
          id: '6',
          class: '6',
          minWeight: 19501,
          maxWeight: 26000,
        },
        {
          id: '7',
          class: '7',
          minWeight: 26001,
          maxWeight: 33000,
        },
        {
          id: '8',
          class: '8',
          minWeight: 33001,
          maxWeight: 999999,
        },
      ],
    });
  }),
];
